import { getOffset } from "../utils/getElementOffset"

function homepageHeader() {
    gsap.registerPlugin(ScrollTrigger)
    gsap.registerPlugin(ScrollToPlugin)

    let windowWidth = window.innerWidth
    let windowHeight = window.innerHeight
    let headerCompleted = false

    // get offset for the letter "i"
    function centerIntroScale(initial) {
        // getting focus element
        let highlightedTextElement = document.querySelector(
            "section.main .intro svg#desktop tspan#focus"
        )
        // get offset values
        let offset = getOffset(highlightedTextElement)
        let originLeftRaw = offset.left
        let originTopRaw = offset.top
        let originWidthRaw = offset.width
        let originHeightRaw = offset.height

        // center offset values
        let originLeft = originLeftRaw + originWidthRaw / 2
        let originTop = originTopRaw + originHeightRaw / 2

        if (initial === false) {
            originTop = originTopRaw + originHeightRaw / 2 - windowHeight
        }

        //set transform origin to the center of the letter "i"
        let transOri = originLeft + "px " + originTop + "px"
        document.querySelector("section.main .intro .content").style.transformOrigin = transOri
    }

    // INITIALIZATION
    // initialization of static header
    // const headerText = "Your brand can do more than you think."
    const headerText = "We’re an integrated branding consultancy."
    const headerDescription = "We help our clients uncover the truth of their brand, then align brand strategy with business strategy for transformative results."
    const headerTextArr = headerText.split(" ")
    let headerHTML = ""

    for (let i = 0; i < headerTextArr.length; i++) {
        // get the last two words and highlight them
        // if (i == headerTextArr.length - 1 || i == headerTextArr.length - 2) {
        // get the third last word and highlight them
        if (i == headerTextArr.length - 3) {
            headerHTML += '<span class="hltr-text">' + headerTextArr[i] + "&nbsp;</span>"
        } else {
            headerHTML += "<span>" + headerTextArr[i] + "&nbsp;</span>"
        }
    }

    const staticHeaderTitle = document.createElement("h1");
    const staticHeaderDescription = document.createElement("p");

    const staticHeader = document.querySelector("section.main .header-static .content");

    staticHeaderDescription.setAttribute('id','copy');

    staticHeaderTitle.innerHTML = headerHTML
    staticHeaderDescription.innerHTML = headerDescription
    
    staticHeader.appendChild(staticHeaderTitle)
    staticHeader.appendChild(staticHeaderDescription)

    // INITIALIZATION
    // initialize timeline
    let header_static_tl = gsap.timeline()

    for (let i = 1; i < headerTextArr.length + 1; i++) {
        header_static_tl.from(
            ".header-static h1 span:nth-child(" + i + ")",
            { y: "100%", filter: "blur(15px)", opacity: 0, duration: 0.5 },
            "<0.08"
        )
    }

    header_static_tl.from(
        ".header-static p#copy",
        { y: "50%", filter: "blur(15px)", opacity: 0, duration: 0.5 },
        "<0.35"
    )

    for (let i = 1; i <= 3; i++) {
        header_static_tl.from(
            ".header-static .btn-list li:nth-child(" + i + ")",
            { y: "100%", filter: "blur(15px)", opacity: 0, duration: 0.5 },
            "<0.08"
        )
    }
    // makes sure the static header animation does not autoplay
    header_static_tl.pause()

    // INITIALIZATION
    // specifies the zoom-thru animation
    let intro = gsap.timeline({
        onStart: () => {
            // kills the svg mask reset interval
            clearInterval(intervalReset)
        },
        onComplete: () => {
            headerObserver.kill()
            headerCompleted = true
            document.querySelector("section.main .intro").remove()
            ScrollTrigger.create({
                trigger: "a#header-top",
                onToggle: () => {
                    header_static_tl.play()
                },
            })
        },
    })
    intro
        .to(
            ".intro .content",
            {
                transform: "scale(150)",
                duration: 0.55,
                ease: "circ.in",
            },
            "<"
        )
        .to(".intro #copy", { opacity: 0, duration: 0.15 }, "<")
        .to(".intro .btn-list", { opacity: 0, duration: 0.15 }, "<")
        .to(".intro svg #tagline tspan", { opacity: 0, duration: 0.15 }, "<")
        .to(".intro", { opacity: 0, duration: 0.35 }, "<+0.5")

    intro.pause()
    // INITIALIZATION
    //landing animation initalization
    let landing_tl = gsap.timeline({
        //when landing animation is completed
        onComplete: () => {
            // document.querySelector("section.main").style.position = "relative"
            gsap.to(window, {
                duration: 0.01,
                scrollTo: ".main-content",
            })
            centerIntroScale(true)
            setTimeout(function () {
                centerIntroScale(false)
                initialObserver.disable()
                headerObserver.enable()
            }, 50)
        },
    })

    //landing animation
    landing_tl.to(".main", { opacity: 1, duration: 0.15 }, "<")
    landing_tl.to(".intro svg #tagline tspan", { fill: "#FFFFFF", duration: 0.5 }, "<0.15")
    landing_tl.to(
        ".intro svg #tagline tspan#hltr-text",
        { fill: "#FFCD00", duration: 0.5 },
        "<"
    )
    landing_tl.to(
        ".intro svg #tagline tspan#hltr-text tspan#focus",
        { fill: "#FFCD00", duration: 0.5 },
        "<"
    )
    landing_tl.from(".intro #copy", { opacity: 0, duration: 0.5 }, "<0.1")
    landing_tl.to(".intro svg #tagline-mask", { opacity: 1, duration: 0.15 }, "<")
    for (let i = 1; i < 4; i++) {
        landing_tl.from(
            ".intro .btn-list li:nth-child(" + i + ")",
            { opacity: 0, duration: 0.5 },
            "<0.05"
        )
    }
    landing_tl.pause()

    // INITIALIZATION
    // disable initial scrolling behaviour
    let initialObserver = ScrollTrigger.observe({
        type: "wheel,touch,pointer",
        wheelSpeed: 0,
        tolerance: 0,
        preventDefault: true,
    })

    // INITIALIZATION
    // initialize header observer and set as disable until after the initial landing animation is done
    let headerObserver = ScrollTrigger.observe({
        target: ".intro",
        type: "wheel,touch,pointer",
        wheelSpeed: -1,
        onUp: () => intro.play(),
        tolerance: 25,
        preventDefault: true,
    })
    headerObserver.disable()

    // Animated Header - Device Conditional
    if (windowWidth > 768) {
        if (headerCompleted === false) {
            landing_tl.play()
        }
    } else {
        // document.querySelector("section.main").style.position = "relative"
        document.querySelector("section.main .intro").remove()
        headerCompleted = true
        header_static_tl.play()
        initialObserver.disable()
        headerObserver.disable()
    }

    // reset on resize
    window.addEventListener("resize", (event) => {
        windowWidth = window.innerWidth
        windowHeight = window.innerHeight
        if (headerCompleted === false) {
            gsap.to(window, { duration: 0.1, scrollTo: ".main-content" })
            centerIntroScale(false)
        }
    })

    let intervalReset = window.setInterval(function () {
        windowWidth = window.innerWidth
        windowHeight = window.innerHeight
        if (headerCompleted === false) {
            // for some reason the svg mask shifts if you resize sometimes, despite there being a listener for resizing.
            // This interval should reset the mask positioning every 0.5s until a better solution is found.
            if (document.querySelector("#mask-desktop").classList != "refresh") {
                document.querySelector("#mask-desktop").classList.add("refresh")
            } else {
                document.querySelector("#mask-desktop").classList.remove("refresh")
            }
        }
    }, 500)
}


homepageHeader()